import { render, staticRenderFns } from "./ReportsDeliverySacPublicView.vue?vue&type=template&id=47c6690a"
import script from "./ReportsDeliverySacPublicView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySacPublicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports